export default "__VITE_ASSET__xH4G23kN__"